import React, { Component } from "react";
import {
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import closeIcon from "../../images/close_icon.png";

export default class AddDocumentType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      responseMsg: "",
      name: "",
    };
  }

  onChangeValue = (value) => {
    this.setState({ name: value });
  };

  notifyFormError(data, msg) {
    alert(msg);
  }

  saveAction = () => {
    var me = this;
    let name = this.state.name;

    if (name == "") {
      alert("Document Type should not blank.");
      return;
    }

    let body = {
      name: name,
    };

    let url = `/api/documentUpload/addDocUploaderType`;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Document type already exist.") {
          this.notifyFormError(res, "Document type is already exist.");
        } else {
          me.props.closeAddNewDocTypeModal();
          console.log("res-------", res);
          alert("Document Type created successfully");
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
      }
    });
  };

  render() {
    let { responseMsg } = this.state;
    let { open, closeAddNewDocTypeModal } = this.props;
    return (
      <div>
        <Dialog open={open} style={{ width: "30%", marginLeft: "35%" }}>
          <Card className="addCompanyHeader">
            <CardTitle title="Document Type" />
            <div className="closeIcon">
              <IconButton
                aria-label="close"
                onClick={closeAddNewDocTypeModal}
                style={{ width: "25px" }}
              >
                <img src={closeIcon} />
              </IconButton>
            </div>
          </Card>
          <TextField
            floatingLabelText="Add Document Name"
            style={{ width: "27rem" }}
            onChange={(e) => this.onChangeValue(e.target.value)}
          />
          <br />
          <div style={{ textAlign: "center" }}>
            <FlatButton
              type="submit"
              className="flatButtonCls"
              onTouchTap={() => this.saveAction()}
            >
              Save
            </FlatButton>
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/AddNewDocumentType.js